import React from "react";
import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";
import {
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Typography,
} from "@material-ui/core";
import Link from "@material-ui/core/Link";
import { NavLink } from "react-router-dom";
import { spacing } from "@material-ui/system";

const Container = styled.div`
  width: 100%;
  height: calc(100vh - 86px - 64px - -48px - 48px - 64px - 200px);
  position: relative;
`;

const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const SteamboatTempFlowForecasts = () => {
  return (
    <>
      <Helmet title="Steamboat Temp/Flow Forecasts" />
      <Typography variant="h3" gutterBottom display="inline">
        City of Steamboat Temp/Flow Forecasts Tool
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} exact to="/dashboard">
          Dashboard
        </Link>
        <Typography>Steamboat Temp/Flow Forecasts</Typography>
      </Breadcrumbs>

      <Divider my={6} />

      <Container>
        <iframe
          src="https://lotichydrological.com/shiny/Yampa_Data_Dashboard/"
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title="City of Steamboat Temp/Flow Forecasts Tool"
        />
      </Container>
    </>
  );
};

export default SteamboatTempFlowForecasts;
